<template>
    <div class="settings-wrapper" :class="{ 'mx-5': !isMobile }">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="d-flex flex-column">
            <div v-if="!resetPass || !isMobile" :class="{ 'mx-3': isMobile }" class="top-info">
                <p class="title">Account Settings</p>
            </div>
            <div v-if="!resetPass || !isMobile" class="divider"></div>
        </div>
        <password-reset-modal
            v-if="resetPass"
            @close="resetPass = false"
        ></password-reset-modal>
        <div class="full-card-wrapper" v-else>
            <div class="personal-page" :style="{ background: isMobile ? 'inherit' : '' }">
                <div class="d-flex flex-column flex-fill personal-page-wrapper">
                    <p class="personal-head">Personal Information</p>
                    <div class="user-card">
                        <div class="d-flex input-wrapper">
                            <div class="inputs-fields">
                                <div v-if="isMobile" class="photo-wrapper-mobile">
                                    <div>
                                        <div class="profile-action-buttons">
                                            <button
                                                class="btn-view-profile"
                                                @click="viewBookerProfile"
                                            >
                                                View Profile
                                            </button>
                                            <button
                                                class="btn-delete-profile"
                                                @click="deleteUserProfile"
                                            >
                                                Delete Profile
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <span class="legend-foto">Profile Picture</span>
                                        </div>
                                    </div>
                                    <div
                                        v-if="!avatar.length && !userInfo.avatar"
                                        class="w-100"
                                    >
                                        <div class="w-100">
                                            <input
                                                ref="photoUpload"
                                                type="file"
                                                @change="selectFile"
                                                accept="image/*"
                                                hidden="hidden"
                                            />
                                            <button
                                                @click="uploadImage"
                                                class="media-upload-btn"
                                            >
                                                <img
                                                    src="/images/icons/media-upload-btn.svg"
                                                    class="upload-btn"
                                                    alt="upload-media-btn"
                                                />
                                                <p class="upload-msg">Upload</p>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="mobile-photo-upload-done-wrapper" v-else>
                                        <div class="photo-upload-done">
                                            <img
                                                :src="
                                                    avatar.length
                                                        ? avatarsrc
                                                        : '/' + userInfo.avatar
                                                "
                                                alt="avatar"
                                                class="avatar-img"
                                            />
                                        </div>
                                        <button @click="removeAvatar" class="btn-call-remove">
                                            {{ avatar.length ? 'Cancel' : 'Delete' }}
                                        </button>
                                    </div>
                                </div>
                                <div class="input-form d-flex flex-column">
                                    <label for="first_name" class="input-label"
                                        >First name *</label
                                    >
                                    <input
                                        class="settings-form settings-form-user"
                                        type="text"
                                        v-model="$v.userInfo.first_name.$model"
                                        id="first_name"
                                    />
                                    <p
                                        class="error-form-message"
                                        v-if="
                                            $v.userInfo.first_name.$dirty &&
                                            $v.userInfo.first_name.$invalid
                                        "
                                    >
                                        {{ firstName }}
                                    </p>
                                </div>
                                <div class="input-form d-flex flex-column">
                                    <label for="last_name" class="input-label"
                                        >Last name *</label
                                    >
                                    <input
                                        class="settings-form settings-form-user"
                                        type="text"
                                        v-model="$v.userInfo.last_name.$model"
                                        id="last_name"
                                    />
                                    <p
                                        class="error-form-message"
                                        v-if="
                                            $v.userInfo.last_name.$dirty &&
                                            $v.userInfo.last_name.$invalid
                                        "
                                    >
                                        {{ lastName }}
                                    </p>
                                </div>
                            </div>
                            <div class="inputs-fields">
                                <div class="input-form d-flex flex-column">
                                    <label for="Email" class="input-label">Email *</label>
                                    <input
                                        class="settings-form settings-form-user"
                                        type="mail"
                                        id="Email"
                                        v-model="$v.userInfo.email.$model"
                                    />
                                    <p
                                        class="error-form-message"
                                        v-if="
                                            $v.userInfo.email.$dirty &&
                                            $v.userInfo.email.$invalid
                                        "
                                    >
                                        {{ this.emailError }}
                                    </p>
                                </div>
                                <div class="input-form d-flex flex-column">
                                    <label for="phone" class="input-label">Phone</label>
                                    <input
                                        class="settings-form settings-form-user"
                                        type="text"
                                        id="phone"
                                        v-mask="'(###)###-####'"
                                        v-model="$v.userInfo.phone_number.$model"
                                    />
                                    <p
                                        class="error-form-message"
                                        v-if="
                                            $v.userInfo.phone_number.$dirty &&
                                            $v.userInfo.phone_number.$invalid
                                        "
                                    >
                                        {{ phoneNumber }}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="select-field"
                                :style="{
                                    'margin-top': this.$v.userInfo.email.$invalid ? '15px' : 0
                                }"
                            >
                                <label for="first_name" class="input-label"> Time Zone</label>
                                <select
                                    v-model="userInfo.timezone"
                                    class="settings-form-select"
                                    id="timezone"
                                >
                                    <option
                                        v-for="(timezone, index) in timezones"
                                        :key="index"
                                        :value="timezone.id"
                                        :selected="timezone.id === userInfo.timezone"
                                    >
                                        {{ timezone.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="booker-fields">
                                <label class="address-label">
                                    Where are you from? *
                                    <input
                                        ref="autocomplete"
                                        v-model="$v.userInfo.address.$model"
                                        class="settings-form settings-form-user"
                                        type="text"
                                        placeholder="address"
                                    />
                                    <p class="error-form-message" v-if="locationError">
                                        {{ address }}
                                    </p>
                                </label>
                                <label class="description-label">
                                    Bio *
                                    <textarea
                                        v-model="$v.userInfo.description.$model"
                                        class="settings-form settings-form-use"
                                    ></textarea>
                                    <p
                                        class="error-form-message"
                                        v-if="
                                            $v.userInfo.description.$dirty &&
                                            $v.userInfo.description.$invalid
                                        "
                                    >
                                        {{ description }}
                                    </p>
                                </label>
                            </div>
                        </div>
                        <div v-if="!isMobile" class="photo-wrapper">
                            <div>
                                <div class="profile-action-buttons">
                                    <button
                                        class="btn-view-profile"
                                        @click="viewBookerProfile"
                                    >
                                        View Profile
                                    </button>
                                    <button
                                        class="btn-delete-profile"
                                        @click="deleteUserProfile"
                                    >
                                        Delete Profile
                                    </button>
                                </div>
                            </div>
                            <div v-if="!avatar.length && !userInfo.avatar">
                                <div class="photo-upload">
                                    <input
                                        hidden="hidden"
                                        type="file"
                                        accept=".jpg , .jpeg, .png"
                                        ref="photoUpload"
                                        @change="selectFile"
                                    />
                                    <button class="btn-load-img" @click="uploadImage">
                                        <span class="btn-upload">Upload</span>
                                    </button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="photo-upload-done">
                                    <img
                                        :src="
                                            avatar.length ? avatarsrc : '/' + userInfo.avatar
                                        "
                                        alt="avatar"
                                        class="avatar-img"
                                    />
                                </div>
                                <button @click="removeAvatar" class="btn-call-remove">
                                    {{ avatar.length ? 'Cancel' : 'Delete' }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        class="d-flex mt-4 pw-link-wrapper"
                        :class="{ 'flex-column': isMobile }"
                    >
                        <a class="pass-reset-link" href="/password/reset">
                            Reset your password
                        </a>
                        <a
                            class="pass-reset-link"
                            :class="{ 'px-5': !isMobile, 'pt-3': isMobile }"
                            @click="resetPass = true"
                        >
                            Change your password
                        </a>
                    </div>
                    <div class="d-flex">
                        <div class="d-flex flex-column btn-wrap button-wrapper">
                            <button
                                @click="editUserData()"
                                class="call-to-action-btn"
                                :disabled="$v.userInfo.$anyError"
                                :style="{ opacity: $v.userInfo.$anyError ? '0.6' : '1' }"
                            >
                                <span class="btn-action-text">Save</span>
                            </button>
                            <button @click="getUserData" class="btn-call-remove">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, watchEffect } from 'vue'
    import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
    import PasswordResetModal from './PasswordResetModal.vue'
    import useCheckScreen from '@/composables/useCheckScreen.js'
    import { profileMixin } from '../../../mixins/user-settings/userSettingsMixin'
    import { useGoogleAPI } from '@/composables/utils/useGoogleAPI'

    export default {
        name: 'ProfileSettings',
        mixins: [profileMixin],
        components: {
            PasswordResetModal
        },
        setup() {
            const autocomplete = ref(null)
            const { isMobile } = useCheckScreen()
            const { apiLoaded, initialize, lat, lng, fullAddress } = useGoogleAPI()

            watchEffect(() => {
                const googleRef = autocomplete.value

                if (apiLoaded.value && ref) {
                    initialize({
                        mode: 'autocomplete',
                        templateRef: googleRef,

                        types: ['(cities)']
                    })
                }
            })

            return { isMobile, autocomplete, lat, lng, fullAddress }
        },
        validations: {
            userInfo: {
                email: {
                    required,
                    email
                },
                first_name: {
                    required,
                    correctFormat: function (value) {
                        return /^[A-Z][a-zA-Z -]+$/.test(value)
                    }
                },
                last_name: {
                    required,
                    correctFormat: function (value) {
                        return /^[A-Z][a-zA-Z -]+$/.test(value)
                    }
                },
                phone_number: {
                    correctFormat: function (value) {
                        return !value || /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/.test(value)
                    }
                },
                description: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(1000)
                },
                address: {
                    required
                },
                lat: {
                    required
                },
                lon: {
                    required
                }
            }
        },
        watch: {
            fullAddress: function (address) {
                if (address) {
                    const { address } = this._formatGoogleAddress(this.fullAddress)
                    this.userInfo.address = address
                    this.userInfo.lat = this.lat
                    this.userInfo.lon = this.lng
                }
            },
            '$v.userInfo.address.$model': {
                handler: function (location) {
                    if (location) {
                        this.$v.userInfo.lat.$touch()
                        this.$v.userInfo.lon.$touch()
                    }
                },
                immediate: true
            }
        },
        methods: {
            _formatGoogleAddress(address) {
                const addressArr = address.split(', ')

                const city = addressArr[0]
                const stateZip = addressArr[1]
                const state = stateZip.split(' ')[0]

                const fullAddress = city + ', ' + state

                return { address: fullAddress, city }
            },
            defaultPic() {
                return '/images/default-artist.png'
            },
            uploadImage() {
                this.$refs.photoUpload.click()
            },
            selectFile(e) {
                let tgt = e.target,
                    files = tgt.files,
                    maxSize = 1000000000
                if (files.length >= 1 || files.length <= 3) {
                    for (let imageFile in files) {
                        if (files[imageFile].size <= maxSize) {
                            this.avatar.push(files[imageFile])
                        } else return
                    }
                }
            }
        },
        computed: {
            locationError() {
                if (
                    !this.$v.userInfo.address &&
                    !this.$v.userInfo.lat &&
                    !this.$v.userInfo.lon
                )
                    return false
                return (
                    (this.$v.userInfo.address.$dirty && !this.$v.userInfo.address.required) ||
                    (this.$v.userInfo.lat.$dirty && !this.$v.userInfo.lat.required) ||
                    (this.$v.userInfo.lon.$dirty && !this.$v.userInfo.lon.required)
                )
            },
            avatarsrc() {
                if (!this.avatar.length) {
                    return this.defaultPic()
                } else return URL.createObjectURL(this.avatar[0])
            }
        },
        async created() {
            await this.getUserData()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    @media screen and (max-width: 600px) {
        .title {
            font-size: 32px !important;
            line-height: 120% !important;
            letter-spacing: -0.64px !important;
        }
        .personal-head {
            font-size: 22px !important;
            letter-spacing: -0.22px !important;
        }
        .personal-page {
            padding: 0px !important;
        }
        .booker-fields {
            flex-direction: column;
        }
    }
    .booker-fields {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-content: center;
        gap: 8px;
    }
    .address-label {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    input {
        width: 100%;
    }
    .description-label {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .settings-wrapper {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        margin-bottom: 100px;
    }
    .top-info p {
        color: #dedede;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .personal-head {
        color: #dedede;
        @include base-font-26;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .top-info {
        display: flex;
        flex-direction: column;
    }
    .divider {
        width: 100%;
        height: 1px;
        background: #646464;
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .full-card-wrapper {
        gap: 20px;
        display: flex;
        flex-direction: column;
    }
    .settings-form {
        display: flex;
        padding: 12px 16px 16px 16px;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        color: #dedede;
    }

    .settings-form-select {
        display: flex;
        padding: 12px 16px 16px 16px;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #646464;
        background: #262626;
        appearance: none;
        color: #dedede;
    }
    .error-form-message {
        color: #ed3c0d;
        margin-bottom: 0px;
    }

    .mt-alerts {
        position: fixed;
        z-index: 999;
        right: 70px;
    }
    .pass-reset-link {
        color: #cdeb09;
        font-family: Instrument Sans;
        font-size: 15px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        cursor: pointer;
    }
    .input-wrapper {
        display: inline-flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        flex: 1;
    }
    .inputs-fields {
        display: flex;
        flex: 1;
        align-items: center;
        gap: 20px;
        width: 100%;
        flex-wrap: wrap;
    }
    .input-label {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .input-form {
        align-items: flex-start;
        gap: 6px;
        flex: 1;
        height: 80px;
    }
    .solo-input {
        display: flex;
        gap: 6px;
        flex-direction: column;
        align-self: stretch;
    }
    .select-field {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        flex: 1;
        align-self: stretch;
    }
    .user-card {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
    }
    .mobile-photo-upload-done-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        .btn-call-remove {
            margin: 20px;
        }
    }
    .photo-upload-done {
        display: flex;
        min-width: 317px;
        min-height: 317px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--25, 10px);
        border: 1.5px solid var(--Gray-4, #8b8b8b);
        position: relative;
    }
    .photo-upload {
        display: flex;
        min-width: 317px;
        min-height: 317px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--25, 10px);
        border: 1.5px solid var(--Gray-4, #8b8b8b);
        position: relative;
    }

    .photo-upload::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1;
        pointer-events: none;
    }
    .avatar-img {
        max-width: 317px;
        max-height: 317px;
    }
    .photo-upload {
        background: url('/images/default-artist.png'), lightgray 50% / cover no-repeat;
        z-index: 2;
    }
    .photo-wrapper-mobile {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
        width: 100%;
    }
    .photo-wrapper {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
    }
    .legend-foto {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%; /* 16.2px */
        letter-spacing: 0.12px;
    }
    .btn-wrap {
        flex: 1;
        align-items: center;
        gap: 8px;
        margin-top: 50px;
    }
    .call-to-action-btn {
        display: flex;
        padding: 11px 30px 12px 30px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        flex: 1;
        border-radius: 100px;
        background: #cdeb09;
        border: none;
        width: 100%;
        max-width: 460px;
    }
    .btn-action-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .btn-call-remove {
        color: #8b8b8b;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        text-decoration-line: underline;
        background: none;
        border: none;
    }
    .btn-upload {
        color: #dedede;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
    }
    .btn-load-img {
        border: none;
        background: none;
        z-index: 3;
    }
    .personal-page {
        background: #262626;
        border-radius: 15px;
        padding: 20px 25px 70px;
        display: flex;
        justify-content: space-between;
        gap: 20px;
        max-width: 1440px;
    }
    .personal-page-wrapper {
        max-width: 100%;
    }
    .button-wrapper {
        max-width: 100%;
    }
    .pw-link-wrapper {
        flex-wrap: wrap;
    }
    .media-upload-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        width: 100%;
        height: 66px;
        background: #262626;
    }
    .upload-btn {
        width: 18px;
        height: 18px;
        object-fit: cover;
    }
    .upload-msg {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
        margin-bottom: 0px;
    }
    .btn-view-profile {
        background: transparent;
        border: 1px solid #cdeb09;
        align-items: center;
        border-radius: 120px;
        color: #cdeb09;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        gap: 4px;
        letter-spacing: 0.14px;
        line-height: 115%;
        padding: 8px 12px;
    }
    .btn-delete-profile {
        background: transparent;
        border: 1px solid #8b8b8b;
        align-items: center;
        border-radius: 120px;
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        gap: 4px;
        letter-spacing: 0.14px;
        line-height: 115%;
        padding: 8px 12px;
    }
</style>
